import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, interval, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from '../../shared/services/loading.service';
import { environment } from 'src/environments/environment';
import {
  retryWhen,
  takeUntil,
  catchError,
  filter,
  switchMap,
} from 'rxjs/operators';

@Component({
  selector: 'app-error503',
  templateUrl: './error503.component.html',
  styleUrls: ['./error503.component.css'],
})
export class Error503Component implements OnInit, OnDestroy {
  environment = environment;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private http: HttpClient,
    private router: Router,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.loadingService.unsetLoading(100);

    // Check if still offline
    of(this.route.snapshot.queryParams)
      .pipe(
        filter((params) => !!params.failedUrl),
        switchMap((params) => this.http.get(params.failedUrl)),
        catchError((err) => {
          if (err.status === 503 || err.status === 0) {
            return throwError(err);
          } else {
            return of(null);
          }
        }),
        retryWhen(() => {
          return interval(15000);
        }),
        switchMap(() => this.route.queryParams),
        takeUntil(this.onDestroy$),
      )
      .subscribe((params) => {
        this.ngOnDestroy();

        if (params.returnUrl) {
          this.router.navigate([params.returnUrl]);
        } else {
          this.router.navigate(['/login']);
        }
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
